import React from 'react';
import cx from 'classnames';

import { NoResults } from 'src/components/Inputs/SearchBar';
import { Tile, TileGroup } from 'src/components/Layout';
import { Pagination } from 'src/components/Blog';

import { Locales, type TLocale } from 'src/lib/constants';
import { renderLoadingTiles, searchBasePath } from 'src/lib/resources-utils';

import styles from './TopicPageTemplate/TopicPageTemplate.module.scss';
import tileStyles from 'src/components/Layout/Tile/Tile.module.scss';

const SearchResultArticles = ({
  topic,
  isLoading,
  results,
  pagination,
  queryString,
  locale = Locales.EN_US,
}: {
  topic?;
  isLoading?;
  results?;
  pagination?;
  queryString?;
  locale?: TLocale;
}) => {
  const { hasPagination, pageNumber, totalPages } = pagination;
  const doneLoadingWithNoResults = isLoading === false && results.length < 1;

  if (isLoading) {
    return <TileGroup>{renderLoadingTiles()}</TileGroup>;
  }

  if (doneLoadingWithNoResults) {
    return <NoResults />;
  }

  if (results.length > 0) {
    return (
      <>
        <TileGroup>
          {results.map((article, i) => {
            return (
              <Tile
                className={tileStyles.tile}
                {...article}
                key={`article-tile-${i}`}
              />
            );
          })}
        </TileGroup>
        {hasPagination && (
          <div className={cx('grid-container', styles.paginationContainer)}>
            <Pagination
              currentPage={pageNumber}
              totalPages={totalPages}
              currentPath={searchBasePath({
                topic,
                queryString,
                withQueryParams: pageNumber > 1,
                pageNumber: pageNumber > 1 && pageNumber,
                locale,
              })}
              prevPath={
                pageNumber === 2
                  ? searchBasePath({ topic, withQueryParams: false, locale })
                  : searchBasePath({
                      topic,
                      queryString,
                      pageNumber: pageNumber - 1,
                      locale,
                    })
              }
              nextPath={searchBasePath({
                topic,
                queryString,
                pageNumber: pageNumber + 1,
                locale,
              })}
              lastPagePath={searchBasePath({
                topic,
                queryString,
                pageNumber: totalPages,
                locale,
              })}
            />
          </div>
        )}
      </>
    );
  }
};

export default SearchResultArticles;
